import * as types from '../types'

export default function (payload) {
  return {
    type: types.SET_TOKENS,
    payload,
  }
}
